import ButtonsPageView from "./ButtonsPageView";

function ButtonsPage() {
  return <ButtonsPageView  />;
}

export default ButtonsPage;